angular.module('picmonicng').directive('workflowCommentNew', [
  function () {
    return {
      restrict: 'E',
      scope: {
        parent: '=',
      },
      controller: [
        '$scope',
        'CommentsResource',
        '$element',
        'Users',
        '$filter',
        function ($scope, CommentsResource, $element, Users, $filter) {
          $scope.tagging = false;
          $scope.tag_buffer = '';
          $scope.slug = $scope.$parent.slug;
          $scope.comments = $scope.$parent.comments;
          $scope.comment_input = $element.find('.comment-textarea');
          $scope.tag_dropdown = $element.find('.tag-dropdown');
          $scope.tag_dropdown_selection_index = 0;
          $scope.users = [];
          $scope.filtered_users = [];

          Users.query({ workflow: true }, function (users) {
            $scope.users = users;
          });

          // Observe mutations on input
          $scope.observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              angular.element(mutation.removedNodes).each(function (value, index) {
                if (this.nodeType === 1) {
                  var node = $(this);
                  if (node.data('user-id') !== undefined) {
                    var user_tag_index = $scope.newComment.tags.indexOf(node.data('user-id'));
                    if (user_tag_index !== -1) {
                      $scope.newComment.tags.splice(user_tag_index, 1);
                    }
                  }
                }
              });
            });
          });

          var config = {
            attributes: true,
            childList: true,
            characterData: true,
          };
          $scope.observer.observe($scope.comment_input[0], config);

          $scope.updateComment = function ($event) {
            $scope.newComment.comment = $event.target.innerHTML;
          };

          $scope.checkTags = function ($event) {
            if ($event.which == 50 && $event.shiftKey === true) {
              // @
              if ($scope.tagging) {
                $event.preventDefault();
                return false;
              } else {
                $scope.tagging = true;
              }
            } else if ($event.which == 40) {
              // Down arrow
              $scope.tag_dropdown_selection_index++;
            } else if ($event.which == 38) {
              // Up arrow
              if ($scope.tag_dropdown_selection_index > 0) {
                $scope.tag_dropdown_selection_index--;
              }
            } else if ($scope.tagging) {
              if ($event.which == 8) {
                $scope.tag_buffer = $scope.tag_buffer.substring(0, $scope.tag_buffer.length - 1);
                if ($scope.tag_buffer.length === 0) {
                  $scope.resetTagging();
                }
                return true;
              } else if ($event.which == 13 || $event.which == 9) {
                $scope.addTag();
                $event.preventDefault();
                return false;
              }
              if ([16].indexOf($event.which) == -1) {
                $scope.tag_buffer += String.fromCharCode($event.which);
                $scope.filtered_users = $filter('filter')($scope.users, $scope.filterUsers);
                if ($scope.filtered_users.length === 0) {
                  $scope.tag_buffer = '';
                  $scope.tagging = false;
                }
              }
            }

            $scope.newComment.comment = $scope.comment_input.html();
          };

          $scope.resetTagging = function () {
            $scope.tagging = false;
            $scope.tag_buffer = '';
            $scope.tag_dropdown_selection_index = 0;
          };

          $scope.filterUsers = function (user) {
            var search_text = (user.first_name + ' ' + user.last_name + ' ' + user.email).toLowerCase();
            return $scope.tag_buffer.length === 0 || search_text.indexOf($scope.tag_buffer.toLowerCase()) !== -1;
          };

          $scope.addTag = function (index) {
            if (index == undefined) {
              index = $scope.tag_dropdown_selection_index;
            }
            $scope.filtered_users = $filter('filter')($scope.users, $scope.filterUsers);
            var user = $scope.filtered_users[index];
            $scope.comment_input.html(
              $scope.comment_input
                .html()
                .replace(
                  new RegExp('@' + $scope.tag_buffer, 'ig'),
                  '<span contenteditable="false" class="tag" data-user-id="' +
                    user.user_id +
                    '">@' +
                    user.first_name +
                    user.last_name +
                    '</span>&nbsp;'
                )
            );
            // Place the cursor after the tag element
            var tag_node = $scope.comment_input.find('span[data-user-id=' + user.user_id + ']');
            if (tag_node.length && typeof window.getSelection != 'undefined') {
              var range = document.createRange();
              range.setStartAfter(tag_node[0]);
              range.collapse(true);
              var selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
            } else {
              $scope.comment_input.focus(false);
            }
            $scope.newComment.tags.push(user.user_id);
            $scope.resetTagging();
          };

          $scope.submitCommment = function () {
            if (!$scope.loading && $scope.newComment.comment) {
              $scope.loading = true;
              $scope.newComment.comment = $scope.newComment.comment.replace(
                /(http.+?)(?=\s|$|<|&nbsp;)/g,
                '<a href="$1" target="_blank">$1</a>'
              );
              CommentsResource.save($scope.newComment).$promise.then(
                function (comment) {
                  $scope.comments.push(comment);
                  $scope.createNewComment();
                  if ($scope.parent) {
                    $scope.parent.showReply = false;
                  }
                  $scope.comment_input.html('');
                  $scope.loading = false;
                },
                function () {
                  $scope.loading = false;
                }
              );
            }
          };

          $scope.createNewComment = function () {
            $scope.newComment = {
              slug: $scope.slug,
              tags: [],
              comment: '',
            };

            if ($scope.parent) {
              $scope.newComment.parent_id = $scope.parent.comment_id;
            }
          };

          $scope.createNewComment();
        },
      ],
      templateUrl: '/templates/directives/workflow-comment-new.html',
      link: function (scope, element, attrs) {
        scope.expanded = false;
        var textArea = element.find('.comment-textarea');
        scope.originalHeight = textArea.height();

        element.on('focusin', function (e) {
          if (!scope.expanded) {
            textArea.animate({
              'min-height': scope.originalHeight * 3,
            });
            scope.expanded = true;
          }
        });

        element.on('focusout', function (e) {
          if (scope.expanded) {
            var textArea = element.find('.comment-textarea');
            textArea.animate({
              'min-height': 48,
            });
            scope.expanded = false;
          }
        });

        element.on('paste', function (event) {
          event.preventDefault();
          document.execCommand('inserttext', false, event.originalEvent.clipboardData.getData('text/plain'));
        });
      },
    };
  },
]);
